import datapoints from '../datapoints';
import removeInboxRuleService from '../services/removeInboxRuleService';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import InboxRuleRetryDialog from '../components/InboxRuleRetryDialog';
import { logUsage } from 'owa-analytics/lib/api';
/**
 * Removes the given rule
 * @param inboxRuleId the inbox rule id
 */
export default select({
    optionState: function () { return store.inboxRulesListState; },
})(action('removeInboxRule', datapoints.removeInboxRuleDatapoint)(function removeInboxRule(inboxRule, force, alwaysDeleteOutlookRulesBlob, state) {
    var optionState = state.optionState;
    var inboxRuleId = inboxRule.Identity.RawIdentity;
    var ruleIdIndex = optionState.inboxRuleIds.indexOf(inboxRuleId);
    if (ruleIdIndex > -1) {
        optionState.inboxRules.delete(inboxRuleId);
        optionState.inboxRuleIds.splice(ruleIdIndex, 1);
    }
    // TODO: Task 20143: Full error handling / success notification support
    return removeInboxRuleService(inboxRule, force, alwaysDeleteOutlookRulesBlob)
        .then(function (response) {
        if (!response.WasSuccessful) {
            // add the rule back to the list on failure
            optionState.inboxRules.set(inboxRuleId, inboxRule);
            optionState.inboxRuleIds.splice(ruleIdIndex, 0, inboxRuleId);
            if (response.UserPrompt) {
                var dialog = new InboxRuleRetryDialog(response.UserPrompt, function (isChecked) {
                    return removeInboxRule(inboxRule, true /*force*/, isChecked /*alwaysDeleteOutlookRulesBlob*/, { optionState: store.inboxRulesListState });
                }, function () { });
                dialog.show();
            }
            logUsage(datapoints.inboxRuleActionFailDatapoint.datapoint.name, [
                'RemoveInboxRule',
            ]);
        }
        return Promise.resolve();
    })
        .catch(function (error) {
        logUsage(datapoints.inboxRuleActionFailDatapoint.datapoint.name, [
            'RemoveInboxRule',
        ]);
        return Promise.resolve();
    });
}));
//# sourceMappingURL=removeInboxRule.js.map